// ======================================================================
// File Name       : GroupTreeContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, Col, Button, Row } from 'react-bootstrap';
import TreeViewDropdowmControl from '../../components/TreeWithDropdownControl';
import DialogConfirm from '../../components/DialogConfirm';
import { canAccess } from '../../utils/AuthedUtils';
import * as groupActions from '../../actions/GroupAction';
import * as Functions from '../../constants/FunctionConstants';
import TREE_ICON from '../../images/tree/group-icon.png';
import { BULK_EXPORT, MSG_DEL_GROUP } from '../../constants/MessageTemplate';
import { showLoading, hideLoading } from '../../utils/PageUtils';
import { WAIT_RENDER_TIME } from '../../constants';
import { isSuperUser } from '../../utils/index';
import { getUserGroupRelation, removedDataUserHasGroupAndRole } from '../../actions/UserAction';
import CustomButton from '../../components/button/CustomButton';
import * as Path from '../../constants/PathConstants';
import * as FUNCTION from '../../constants/FunctionConstants';
import * as ICON from '../../constants/IconConstants';
import CustomLink from '../../components/button/CustomLink'

class GroupTreeContainer extends Component {
  constructor() {
    super();
    this.state = {
      groupSecernId: '',
      isSearchOnCondition: true,
      showButtonAddGroup: false,
    };
    this.searchCondition = this.searchCondition.bind(this);
    this.handleSearchBtn = this.handleSearchBtn.bind(this);
    this.handleRegister = this.handleRegister.bind(this);
    this.handleDetail = this.handleDetail.bind(this);
    this.getSearchResult = this.getSearchResult.bind(this);
    this.hideLoading = this.hideLoading.bind(this);
  }

  componentWillMount() {
    const { dispatch, authedUser } = this.props;
    const userInfoAuthed = authedUser.userInfo;
    const { displayUserType } = userInfoAuthed;
    const userSecernId = authedUser.userInfo.userSecernId;
    const checkSuperUser = isSuperUser(displayUserType);
    if (!checkSuperUser) {
      dispatch(getUserGroupRelation(userSecernId, true)).then((result) => {
        let isUserHasGroup = false;
        if (result.data && result.data.recordNum) {
          isUserHasGroup = true;
        }
        dispatch(groupActions.fetchGroupStructure());
        if (!isUserHasGroup) {
          this.setState({ showButtonAddGroup: true });
        }
      });
    } else {
      dispatch(groupActions.fetchGroupStructure());
      this.setState({ showButtonAddGroup: true });
    }
  }

  componentWillUnmount() {
    this.props.dispatch(removedDataUserHasGroupAndRole());
  }

  searchCondition(filterText, node) {
    const nodeData = node.data.callbackData;
    const { groupName } = this.props.filterData;

    const cond1 = nodeData.groupName.indexOf(groupName) > -1;
    return cond1;
  }

  handleSearchBtn() {
    // reset search
    this.getSearchResult(false, []);
    let isSearchOnCondition = false;
    const { groupName } = this.props.filterData;
    if (!this.treeInstance) {
      return;
    }
    this.props.dispatch(showLoading()).then(() => {
      const self = this;
      if (groupName) {
        isSearchOnCondition = true;
      }
      if (isSearchOnCondition) {
        setTimeout(() => { self.treeInstance.search(self.props.filterData); }, WAIT_RENDER_TIME);
      } else {
        setTimeout(() => { self.treeInstance.clearSearch(); }, WAIT_RENDER_TIME);
      }
    });
  }

  handleRegister(menuData, { callbackData = {} } = {}) {
    const { dispatch } = this.props;
    const { groupSecernId } = callbackData;
    dispatch(groupActions.resetInitData());
    dispatch(groupActions.openGroupRegisterDialog(groupSecernId));
  }

  handleDetail(menuData, { callbackData = {} } = {}) {
    const { dispatch } = this.props;
    const { groupSecernId } = callbackData;
    dispatch(groupActions.openGroupDetailDialog(groupSecernId));
  }

  buildMenuBtn(isDelete) {
    const TREE_MENU = {
      [Functions.GROUP_REGISTER]: {
        icon: 'bi bi-plus-lg',
        text: '新規登録',
        onClick: this.handleRegister,
      },
      [Functions.GROUP_DETAIL]: {
        icon: 'bi bi-info-circle',
        text: '詳細',
        onClick: this.handleDetail,
      },
      [Functions.GROUP_DELETE]: {
        icon: 'bi bi-x-circle',
        text: ' 削除',
        onClick: this.props.handleDelete,
      },
    };
    const menu = [
      Functions.GROUP_REGISTER,
      Functions.GROUP_DETAIL,
    ];
    if (isDelete) {
      menu.push(Functions.GROUP_DELETE);
    }
    return menu.reduce((acc, functionName) => {
      if (canAccess(functionName)) {
        acc.push(TREE_MENU[functionName]);
      }
      return acc;
    }, []);
  }


  /**
   * Build tree
   */
  createTree(isUserHasGroup) {
    const { bySecernId, groupList } = this.props;
    const menuNotDelete = this.buildMenuBtn(false);
    const menuHasDelete = this.buildMenuBtn(true);

    const tree = [];
    const nodeMapper = {};

    for (const group of groupList) {
      const menu = menuHasDelete;

      const arrElem = {
        id: group.groupSecernId,
        text: group.groupName,
        icon: TREE_ICON,
        data: { menu, callbackData: group },
      };
      arrElem.parentGroupSecernId = group.parentGroupSecernId;
      arrElem.children = [];
      nodeMapper[group.groupSecernId] = arrElem;
    }

    for (const key in nodeMapper) {
      const node = nodeMapper[key];
      if (!node.parentGroupSecernId || !nodeMapper[node.parentGroupSecernId]) {
        if (isUserHasGroup) {
          node.data.menu = menuNotDelete;
        }
        tree.push(node);
      }
      else {
        nodeMapper[node.parentGroupSecernId].children.push(node);
      }
    }
    return tree;
  }

  getSearchResult(isSearchCondition, resultList) {
    if (this.props.updateSearchResult) {
      this.props.updateSearchResult(isSearchCondition, resultList);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const shouldNotUpdate =
    nextProps.bySecernId === this.props.bySecernId &&
    nextProps.allSecernIds === this.props.allSecernIds;
    return !shouldNotUpdate;
  }

  hideLoading() {
    this.props.dispatch(hideLoading());
  }

  render() {
    // Build nodes
    const isUserHasGroup = this.props.recordNumUserGroupRelationUserLoging > 0 ? true : false;
    const { handleExportBtn } = this.props;
    const nodes = this.createTree(isUserHasGroup);
    return (
      <div>
        <Form className='form-horizontal' onSubmit={(e) => { e.preventDefault(); }}>
          <Form.Group className="margin-top-20 text-center">
            <Row className="margin-bottom-15">
              <Col sm={12} className="margin-top-20">
                <CustomButton
                  btnStyle="btn btn-primary btn-96"
                  handleClick={this.handleSearchBtn}
                  text="検索"
                  iconClass="bi bi-search"
                />
              </Col>
            </Row>
          </Form.Group>
          <Form.Group className="margin-top-20 text-center">
            <Row className="margin-bottom-15">
              <Col Col sm={9} className="inline-flex">
                {canAccess(Functions.GROUP_REGISTER) && this.state.showButtonAddGroup && (
                  <CustomLink
                    className="margin-right-7 btn-register margin-right-10"
                    onClick={this.handleRegister}
                    text="ユーザーグループ追加"
                    icon={ICON.REGIST}
                  />
                )}
                {canAccess(Functions.GROUP_IMPORT) &&(
                  <CustomLink
                    className="margin-right-7 btn-csv-import"
                    to={Path.GROUP_IMPORT}
                    text="CSV一括投入"
                    icon={ICON.IMPORT}
                  />
                )}
              </Col>
              <Col sm={3}>
                <CustomButton
                  btnStyle="btn btn-export-csv float-end"
                  handleClick={handleExportBtn}
                  iconClass="bi bi-download"
                  text="一括出力"
                />
              </Col>
            </Row>
          </Form.Group>
        </Form>
        <TreeViewDropdowmControl
          data={nodes}
          ref={(instance) => {
            this.treeInstance = instance;
          }}
          searchOnCondition={this.searchCondition}
          getSearchResult={this.getSearchResult.bind(this)}
          isSearchOnCondition={this.state.isSearchOnCondition}
          hideLoading={this.hideLoading}
        />
      </div>
    );
  }
}

GroupTreeContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  bySecernId: PropTypes.shape().isRequired,
  allSecernIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { structures, groupList } = state.group;
  const { authedUser } = state.authed;
  const { recordNumUserGroupRelationUserLoging } = state.user;
  return ({ ...structures, authedUser, recordNumUserGroupRelationUserLoging, groupList });
};

export default connect(mapStateToProps, null, null, { withRef: true })(GroupTreeContainer);
